/* eslint-disable react/react-in-jsx-scope */
import SubCategoryChangeLabelPresentation from "../../presentation/subcategory.changelabel.presentation/subcategory.changelabel.presentation";

const SubCategoryChangeLabelContainer = () => {
  return <SubCategoryChangeLabelPresentation />
}

export default SubCategoryChangeLabelContainer
